enum CurrencySymbolEnum {
    CZK = "Kč",
    EUR = "€"
}

export default CurrencySymbolEnum;
